import { render, staticRenderFns } from "./NurseOnboardingStep.vue?vue&type=template&id=2ff0a7da&scoped=true&"
import script from "./NurseOnboardingStep.vue?vue&type=script&lang=js&"
export * from "./NurseOnboardingStep.vue?vue&type=script&lang=js&"
import style0 from "./NurseOnboardingStep.vue?vue&type=style&index=0&id=2ff0a7da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff0a7da",
  null
  
)

export default component.exports